import * as model from '@/model';
import { FlowHttpRequestOptions, mixHeadersOptions, pick } from '@snfe/flow-yapi-helpers';
import http from '../http';

/**
 * @desc id=1520261, catid=258169, projectId=41427, created=2025-05-13 11:16:36, last-modified=2025-05-13 11:18:29
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/api/scholarship/save)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1520261)
 */
export function postApiScholarshipSave(params: model.api.IPostApiScholarshipSaveParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.api.IPostApiScholarshipSaveResponse>('/api/scholarship/save', {
    data: pick(params, ['realName', 'email', 'institution', 'laboratory', 'paperLink', 'userId']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1520278, catid=258169, projectId=41427, created=2025-05-13 11:25:33, last-modified=2025-05-13 11:26:30
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/api/recommendation/create)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1520278)
 */
export function postApiRecommendationCreate(params: model.api.IPostApiRecommendationCreateParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.api.IPostApiRecommendationCreateResponse>('/api/recommendation/create', {
    data: pick(params, ['token', 'recommendeeName', 'reason', 'userId']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1520246, catid=258169, projectId=41427, created=2025-05-13 11:09:14, last-modified=2025-05-13 11:11:56
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/api/user/verification/submit)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1520246)
 */
export function postApiUserVerificationSubmit(params: model.api.IPostApiUserVerificationSubmitParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.api.IPostApiUserVerificationSubmitResponse>('/api/user/verification/submit', {
    data: pick(params, ['realName', 'idCardType', 'idCardNo', 'institution', 'email']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1520263, catid=258169, projectId=41427, created=2025-05-13 11:18:57, last-modified=2025-05-13 11:20:04
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/api/scholarship/submit)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1520263)
 */
export function postApiScholarshipSubmit(params: model.api.IPostApiScholarshipSubmitParameter, options?: FlowHttpRequestOptions) {
  return http.post<model.api.IPostApiScholarshipSubmitResponse>('/api/scholarship/submit', {
    data: pick(params, ['id', 'userId']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1520276, catid=258169, projectId=41427, created=2025-05-13 11:23:57, last-modified=2025-05-13 11:25:14
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/api/recommendation/generate-link)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1520276)
 */
export function postApiRecommendationGenerateLink(
  params: model.api.IPostApiRecommendationGenerateLinkParameter,
  options?: FlowHttpRequestOptions
) {
  return http.post<model.api.IPostApiRecommendationGenerateLinkResponse>('/api/recommendation/generate-link', {
    data: pick(params, ['applicationId']),
    ...mixHeadersOptions(options, { 'Content-Type': 'application/json' }),
  });
}

/**
 * @desc id=1520283, catid=258169, projectId=41427, created=2025-05-13 11:26:57, last-modified=2025-05-13 11:27:48
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/api/recommendation/status)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1520283)
 */
export function getApiRecommendationStatus(params: model.api.IGetApiRecommendationStatusParameter, options?: FlowHttpRequestOptions) {
  return http.get<model.api.IGetApiRecommendationStatusResponse>('/api/recommendation/status', {
    params: pick(params, ['applicationId']),
    ...options,
  });
}

/**
 * @desc id=1520260, catid=258169, projectId=41427, created=2025-05-13 11:14:50, last-modified=2025-05-13 11:16:06
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/api/scholarship/form-data)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1520260)
 */
export function getApiScholarshipFormData(params: model.api.IGetApiScholarshipFormDataParameter, options?: FlowHttpRequestOptions) {
  return http.get<model.api.IGetApiScholarshipFormDataResponse>('/api/scholarship/form-data', {
    params: pick(params, ['userId']),
    ...options,
  });
}

/**
 * @desc id=1520269, catid=258169, projectId=41427, created=2025-05-13 11:20:24, last-modified=2025-05-13 11:22:12
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/api/scholarship/detail)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1520269)
 */
export function getApiScholarshipDetail(params: model.api.IGetApiScholarshipDetailParameter, options?: FlowHttpRequestOptions) {
  return http.get<model.api.IGetApiScholarshipDetailResponse>('/api/scholarship/detail', {
    params: pick(params, ['id']),
    ...options,
  });
}

/**
 * @desc id=1520274, catid=258169, projectId=41427, created=2025-05-13 11:22:34, last-modified=2025-05-13 11:23:34
 * @see [Yapi接口mock地址](http://yapi.sankuai.com/mock/41427/api/scholarship/winners)
 * @see [Yapi接口地址](http://yapi.sankuai.com/project/41427/interface/api/1520274)
 */
export function getApiScholarshipWinners(options?: FlowHttpRequestOptions) {
  return http.get<model.api.IGetApiScholarshipWinnersResponse>('/api/scholarship/winners', {
    ...options,
  });
}
